import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { STICKY } from "@/constants/testIds";

export default function MobileStickyBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const bookEl = document.querySelector("#book");
      const bookTop = bookEl ? bookEl.getBoundingClientRect().top + window.scrollY : Infinity;
      const passedHero = y > window.innerHeight * 0.6;
      const beforeBooking = y < bookTop - window.innerHeight * 0.5;
      setVisible(passedHero && beforeBooking);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onClick = (e) => {
    e.preventDefault();
    document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      data-testid={STICKY.root}
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 px-4 pb-4 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="bg-white/95 backdrop-blur-xl border border-black/15 px-3 py-3 shadow-[0_20px_60px_-20px_rgba(10,10,10,0.25)]">
        <a
          href="#book"
          data-testid={STICKY.cta}
          onClick={onClick}
          className="btn-primary w-full justify-center"
        >
          Book My Intro Call <ArrowRight size={14} />
        </a>
      </div>
    </div>
  );
}
